import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Form, Typography, Table, Button, Input, Icon, Spin, Select, DatePicker, InputNumber } from 'antd';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';
import ViewList from '@material-ui/icons/ViewList';
// import { green } from '@material-ui/core/colors';
import Highlighter from 'react-highlight-words';
import * as SignalR from '@aspnet/signalr';
import moment from 'moment';
import 'antd/dist/antd.css';

const { Title } = Typography;
const { Option } = Select;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;

@inject(
    'GuestLoginLogStore'
)
@observer
class GuestLoginLogListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: '',
            fromDate: undefined,
            toDate: undefined,
            roomNumber: '',
            guestName: '',
            pagination: {
                current: 1,
                pageSize: 10,
            }
        }
    }

    componentDidMount() {
        let fromDateTime = moment();
        fromDateTime.hour(0);
        fromDateTime.minute(0);
        fromDateTime.second(0);

        let toDateTime = moment();
        toDateTime.hour(23);
        toDateTime.minute(59);
        toDateTime.second(0);

        this.setState({
            fromDate: fromDateTime,
            toDate: toDateTime,
            roomNumber: '',
            guestName: ''
        }, () => {
            const { pagination } = this.state;
            this.getFilterData({ pagination });
        });

        let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
        connection.start().catch(function (err) { return console.error(err.toString()); });
        connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
    }

    // Server Table Pagination

    getFilterData = (params = {}) => {
        const fromDate = moment(this.state.fromDate).format('YYYY-MM-DDTHH:mm:ss')
        const endDate = moment(this.state.toDate).format('YYYY-MM-DDTHH:mm:ss')

        this.props.GuestLoginLogStore.initGuestLoginLog(
            fromDate,
            endDate,
            params.pagination.current,
            params.pagination.pageSize,
            this.state.roomNumber,
            this.state.guestName
        ).then(() => {
            const { totalData } = this.props.GuestLoginLogStore;

            this.setState({
                pagination: {
                    ...params.pagination,
                    total: totalData
                }
            })
        });
    }

    handleTableChange = (pagination, filters, sorter) => {
        this.getFilterData({
            sortField: sorter.field,
            sortOrder: sorter.order,
            pagination,
            ...filters,
        });
    }

    // ON CLICK

    updateGuestLoginLogOnClick = (id) => {
        this.props.GuestLoginLogStore.initUpdateGuestLoginLog(id);
    }

    // TABLE SETTING

    getColumns = () => {
        const { t } = this.props;
        return [
            {
                title: t('Login Date'),
                dataIndex: 'loginDateString',
                key: 'loginDateString',
            },
            {
                title: t('Room Number'),
                dataIndex: 'roomNumber',
                key: 'roomNumber',
            },
            {
                title: t('Guest Name'),
                dataIndex: 'guestName',
                key: 'guestName',
            },
        ]
    }

    getColumnSearchProps = dataIndex => {
        const { t } = this.props;
        return {
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={node => {
                            this.searchInput = node
                        }}
                        placeholder={t('Search') + ' ' + dataIndex}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Button
                        type='primary'
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon='search'
                        size='small'
                        style={{ width: 90, marginRight: 8 }}
                    >
                        {t('Search')}
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size='small' style={{ width: 90 }}>
                        {t('Reset')}
                    </Button>
                </div>
            ),
            filterIcon: filtered => (
                <Icon type='search' style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
            onFilter: (value, record) =>
                record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => this.searchInput.select())
                }
            },
            render: text =>
                this.state.searchedColumn === dataIndex ? (
                    <Highlighter
                        highlightStyle={{ padding: 0 }}
                        searchWords={[this.state.searchText]}
                        autoEscape
                        textToHighlight={text.toString()}
                    />
                ) : (
                    text
                ),
        }
    }

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    fromDateChange = (e) => {
        this.setState({
            fromDate: e
        })
    }

    toDateChange = (e) => {
        this.setState({
            toDate: e
        })
    }

    roomNumberChange = (e) => {
        this.setState({
            roomNumber: e.target.value
        })
    }

    guestNameChange = (e) => {
        this.setState({
            guestName: e.target.value
        })
    }

    searchData = () => {
        const { pagination } = this.state;
        this.getFilterData({ pagination });
    }

    render() {
        const { t } = this.props;
        const {
            guestLoginLogs,
            guestLoginLogListLoading,
        } = this.props.GuestLoginLogStore;

        const { pagination } = this.state;

        return (
            <React.Fragment>
                <Form layout='horizontal'>
                    <div style={{ marginBottom: 20 }}>
                        <Title level={3}>{t('List')}</Title>
                        <div style={{ display: 'flex', alignItems: 'center', height: 48 }}>
                            <div style={{ paddingRight: 8 }}>{t('From Date')}</div>
                            <div style={{ paddingRight: 16 }}>
                                <DatePicker
                                    format='YYYY/MM/DD'
                                    value={this.state.fromDate}
                                    onChange={(e) => this.fromDateChange(e)}
                                />
                            </div>
                            <div style={{ paddingRight: 8 }}>{t('To Date')}</div>
                            <div style={{ paddingRight: 16 }}>
                                <DatePicker
                                    format='YYYY/MM/DD'
                                    value={this.state.toDate}
                                    onChange={(e) => this.toDateChange(e)}
                                />
                            </div>
                            <div style={{ paddingRight: 8 }}>{t('Room Number')}</div>
                            <div style={{ paddingRight: 16 }}>
                                <Input value={this.state.roomNumber} placeholder={t('Room Number')} onChange={this.roomNumberChange} />
                            </div>
                            <div style={{ paddingRight: 8 }}>{t('Guest Name')}</div>
                            <div style={{ paddingRight: 16 }}>
                                <Input value={this.state.guestName} placeholder={t('Guest Name')} onChange={this.guestNameChange} />
                            </div>
                            <div>
                                <Button onClick={this.searchData}>{t('Search')}</Button>
                            </div>
                        </div>
                    </div>
                    <Spin spinning={guestLoginLogListLoading}>
                        <Table
                            columns={this.getColumns()}
                            rowKey={record => record.id}
                            dataSource={guestLoginLogs}
                            pagination={pagination}
                            onChange={this.handleTableChange} />
                    </Spin>
                </Form>
            </React.Fragment>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(GuestLoginLogListPage);